:host {
  display: block;
  margin-bottom: var(--cms-components-mb);
}

.video-inner {
  @include cms-default-grid-container;
  background: none;
  border: none;
  width: 100%;
  position: relative;
  cursor: pointer;
  margin: 0 auto;
}

.cms-video {
  grid-area: var(--cms-default-grid-area);
}


@include media-width($breakpoint-md) {
  .cms-video {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}